import type { RichVessel } from '../data/vesselEnrich';
import type { VesselFilter } from '../data/types';

function matchesQuery(v: RichVessel, q: string): boolean {
  if (!q) return true;
  const hay = [v.name, v.mmsi, v.imo, v.callsign, v.destination, v.vesselType, v.flag]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  return hay.includes(q.toLowerCase());
}

export function applyVesselFilter(vessels: RichVessel[], filter: VesselFilter): RichVessel[] {
  return vessels.filter((v) => {
    if (!matchesQuery(v, filter.query)) return false;
    if (filter.iconKinds.length && !filter.iconKinds.includes(v.iconKind)) return false;
    if (filter.classes.length && !filter.classes.includes(v.vesselClass)) return false;
    if (filter.flags.length && (!v.flag || !filter.flags.includes(v.flag))) return false;
    if (filter.vesselTypes.length && (!v.vesselType || !filter.vesselTypes.includes(v.vesselType))) return false;
    if (filter.navStatuses.length && (!v.navStatus || !filter.navStatuses.includes(v.navStatus))) return false;
    if (filter.speedMin != null && (v.speed == null || v.speed < filter.speedMin)) return false;
    if (filter.speedMax != null && (v.speed == null || v.speed > filter.speedMax)) return false;
    return true;
  });
}
